import type { FC, ReactNode } from 'react'
import type { OrderStatus } from '@/types'

import { Pill } from '@/components/admin/admin-ui'
import { ORDER_STATUSES } from '@/constants/site'

const TONES: Record<OrderStatus, 'pink' | 'amber' | 'green' | 'neutral'> = {
    baru: 'pink',
    diproses: 'amber',
    selesai: 'green',
    dibatalkan: 'neutral'
}

export const OrderStatusPill: FC<{ status: OrderStatus }> = ({ status }): ReactNode => (
    <Pill tone={TONES[status]}>
        {ORDER_STATUSES.find(entry => entry.id === status)?.label ?? status}
    </Pill>
)
